
export default function CTA() {
  return (
    <section id="contact" className="py-20 bg-gradient-to-br from-teal-500 to-emerald-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Get Your Free Insurance Consultation Today
          </h2>
          <p className="text-xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
            Stop overpaying for health insurance. Let Houston's #1 rated experts help you find affordable, comprehensive coverage tailored to your needs.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <a href="tel:2812062619" className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer">
              <i className="ri-phone-line mr-2"></i>
              Call (281) 206-2619
            </a>
            <a href="#top-agencies" className="bg-teal-700 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-teal-800 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer">
              View All Agencies
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">10+</div>
              <div className="text-white/90">Top-Rated Agencies</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">1000+</div>
              <div className="text-white/90">Satisfied Clients</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-2">25+</div>
              <div className="text-white/90">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
